import { CalendarService } from '../../api';
import { useItems } from './useItems';

const fetcher = async ({ startDate, endDate }: { startDate: string; endDate: string }) =>
  CalendarService.getCalendarShifts(startDate, endDate);

type UseShiftsProps = { startDate: string; endDate: string };

export const useShifts = ({ startDate, endDate }: UseShiftsProps) => {
  const { items, error, isLoading, deleteItem, addItem, updateItem, addItems } = useItems({
    startDate,
    endDate,
    opId: 'getCalendarShifts',
    fetcher,
  });

  return {
    items: items || {},
    isLoading,
    isError: error,
    deleteItem,
    addItem,
    updateItem,
    addItems,
  };
};
